import {
  select,
  min,
  scaleLinear,
  scaleBand,
  timeFormat,
  axisBottom,
  axisLeft,
  selectAll,
  max,
  interpolateRgb,
} from "d3";
import { sortByKey } from "../_helpers/_helpers.js";
import { textactive } from "@/_core/_helpers/_parametric_tools";

export const MacroChart = function(_parentElement, _childElement, _context) {
  this.parentElement = _parentElement;
  this.childElement = _childElement;
  this.context = _context;
  this.filtered = [];
};

MacroChart.prototype.initVis = function(
  _chartData,
  _selectedDateId,
  _selectedCountryId,
  _colorSelection,
  _formatYAxis,
  _dateFormat,
  colorTheme,
  logo,
) {
  this.filtered = [];
  var vis = this;
  vis.chartDiv = document.getElementById(vis.parentElement);
  // Extract the width and height that was computed by CSS.
  vis.width = vis.chartDiv.clientWidth;
  vis.height = vis.chartDiv.clientHeight;
  vis.margin = {
    top: vis.height * 0.01,
    right: Math.min(vis.width * 0.15, 200),
    bottom: vis.height * 0.05,
    left: Math.min(vis.width * 0.05, 60),
  };
  vis.data = _chartData;
  vis.dateFormat = _dateFormat;
  vis.formatYAxis = _formatYAxis;
  vis.colorSelection = _colorSelection;
  vis.widthBar = 0.4;
  vis.decoBar = 0.6;
  vis.lineWidthChart = 1;
  vis.selectedDateId = _selectedDateId;
  vis.selectedCountryId = _selectedCountryId;
  vis.sortRef = vis.data.series[vis.selectedDateId].values;
  vis.colorTheme = colorTheme;
  // create SVG and size it
  select("#svg-fundamentals")
    .select("svg > *")
    .remove();
  vis.svg = select("#svg-fundamentals")
    .attr("width", vis.width)
    .attr("height", vis.height)
    .append("g");
  // vis.svg
  //   .append("line")
  //   .attr("class", "xAxisLine")
  //   .attr("x1", vis.margin.left)
  //   .attr("y1", vis.margin.top)
  //   .attr("x2", vis.width - vis.margin.right)
  //   .attr("y2", vis.margin.top);
  let logoSize = 50;
  let offst = 20;
  let yPos = offst;
  let xPos = logoSize + offst;
  vis.svg
    .append("image")
    .attr("xlink:href", logo)
    .attr("x", vis.width - vis.margin.right - xPos + "px")
    .attr("y", vis.margin.top + yPos)
    .attr("width", logoSize + "px")
    .attr("height", logoSize + "px")
    .style("opacity", 0.3);

  // set the y range and domain
  vis.minimal = Math.min(
    0,
    min(vis.data.series, (d) => min(d.values)),
  );
  vis.maximal = Math.max(
    0,
    max(vis.data.series, (d) => max(d.values)),
  );
  vis.dlt = (vis.maximal - vis.minimal) * 0.025;
  vis.minimal -= vis.minimal === 0 ? 0 : vis.dlt;
  vis.maximal += vis.maximal === 0 ? 0 : vis.dlt;
  vis.y = scaleLinear()
    .range([vis.height - vis.margin.bottom, vis.margin.top])
    .domain([vis.minimal, vis.maximal]);

  // vis.limit = max(sortRef, function(d) { return Number.isFinite(d) ? Math.abs(d) : 0; });
  vis.limit = Math.max(Math.abs(vis.minimal), Math.abs(vis.maximal));
  vis.colorLimits = [
    -vis.limit,
    -vis.limit * 0.5,
    0,
    vis.limit * 0.5,
    vis.limit,
  ];
  // Data and color scale
  vis.color = scaleLinear()
    .domain(vis.colorLimits)
    .range(vis.colorSelection)
    .interpolate(interpolateRgb); //interpolateHsl interpolateHcl interpolateRgb;

  // set the x range and domain
  vis.x = scaleBand()
    .range([vis.margin.left, vis.width - vis.margin.right])
    .domain(
      vis.data.dates.map(function(d) {
        return d;
      }),
    );
  // .domain(extent(data.dates));
  vis.xAxis = (g) =>
    g
      .attr("transform", `translate(0,${vis.height - vis.margin.bottom})`)
      .attr("class", "axis axis--x")
      .call(
        axisBottom(vis.x)
          .tickSizeOuter(0)
          .tickFormat(timeFormat(vis.dateFormat)),
      );

  vis.barwidth = vis.x.bandwidth(); // from scale
  vis.candlewidth =
    Math.floor(min([vis.barwidth * vis.widthBar, 1000000]) / 2) * 2 + 1; // give space between bars
  vis.delta = Math.round((vis.barwidth - vis.candlewidth) / 2); // space given

  // include background style for selected date
  vis.svg
    .append("rect")
    .attr("x", vis.x(vis.data.dates[vis.selectedDateId]) + vis.delta)
    .attr("y", vis.y(vis.maximal))
    .attr("height", vis.height - vis.margin.top - vis.margin.bottom)
    .attr("width", vis.candlewidth)
    .attr("class", "bkgrnd");

  vis.svg
    .append("g")
    .attr("class", "axis axis--y axis--y-fund")
    .attr("transform", `translate(${vis.margin.left}, 0 )`)
    .call(
      axisLeft(vis.y)
        .tickFormat(vis.formatYAxis) // TODO: ojo si no todos estan en %
        .tickPadding(10)
        .tickSize(-vis.width + vis.margin.right + vis.margin.left)
        .ticks(8),
    );
  // add the x Axis
  vis.svg
    .append("g")
    .attr("class", "axis axis--x")
    .call(vis.xAxis);

  // add a horizontal line at y = 0
  if (Math.sign(vis.minimal * vis.maximal) < 0) {
    vis.svg
      .append("line")
      .attr("class", "xAxisLine")
      .attr("x1", vis.margin.left)
      .attr("y1", vis.y(0))
      .attr("x2", vis.width - vis.margin.right)
      .attr("y2", vis.y(0));
  }

  // x axis decoration
  vis.decowidth =
    Math.floor(min([vis.barwidth * vis.decoBar, 1000000]) / 2) * 2 + 1; // give space between bars
  vis.decodelta = Math.round((vis.barwidth - vis.decowidth) / 2); // space given
  vis.decoLines = vis.svg
    .selectAll(".decoLines")
    .data([vis.data.dates])
    .enter()
    .append("g")
    .attr("class", "decoLines")
    .attr("id", "decoLinesid");
  vis.decoLines
    .selectAll("line")
    .data(function(d) {
      return d;
    })
    .enter()
    .append("line")
    .attr("x1", function(d) {
      return vis.x(d) + vis.decodelta;
    })
    .attr("x2", function(d) {
      return vis.x(d) + vis.decodelta + vis.decowidth;
    })
    .attr("y1", vis.y(vis.minimal))
    .attr("y2", vis.y(vis.minimal))
    .attr("width", vis.decowidth)
    .style("display", null)
    .attr("height", 4);

  // binding lines
  vis.bindLines = vis.svg
    .selectAll(".bindLines")
    .data(vis.data.bind.slice(1))
    .enter()
    .append("g")
    .attr("class", "bindLines")
    .attr("id", "bindLinesid")
    .attr("transform", function(d) {
      return "translate(" + vis.x(d.date) + ",0)";
    });
  vis.bindLines
    .selectAll("line")
    .data(function(d) {
      return vis.data.country.map(function(key, i) {
        return { y1: d.y1[i], y2: d.y2[i], idx: key };
      });
    })
    .enter()
    .append("line")
    .attr("x1", -vis.delta)
    .attr("x2", +vis.delta)
    .attr("y1", function(d) {
      return vis.y(d.y1);
    })
    .attr("y2", function(d) {
      return vis.y(d.y2);
    })
    .style("opacity", function(d) {
      return +isFinite(d.y1) && +isFinite(d.y2);
    })
    .attr("class", function(d) {
      return "bindLine" + d.idx;
    })
    .style("display", null)
    .classed("highlightedBind", function(d) {
      return d.idx === vis.selectedCountryId;
    });

  // main lines
  vis.mainLines = vis.svg
    .selectAll(".mainLines")
    .data(vis.data.series)
    .enter()
    .append("g")
    .attr("class", "mainLines")
    .attr("id", "mainLinesid")
    .attr("transform", function(d) {
      return "translate(" + vis.x(d.date) + ",0)";
    });
  vis.mainLines
    .selectAll("rect")
    .data(function(d) {
      return vis.data.country.map(function(key, i) {
        return {
          key: key,
          value: d.values[i],
          color: vis.sortRef[i],
          idx: key,
          date: d.date,
          country: vis.data.country_long[i],
        };
      });
    })
    .enter()
    .append("rect")
    .attr("x", vis.delta)
    .attr("y", function(d) {
      return Number.isFinite(d.value) ? vis.y(d.value) - 1 : 0;
    })
    .style("opacity", function(d) {
      return +isFinite(d.value);
    })
    .attr("class", function(d) {
      return "mainLine" + d.idx;
    })
    .attr("width", vis.candlewidth)
    .attr("height", 4)
    .attr("stroke", function(d) {
      return vis.color(isFinite(d.value) ? d.value : 0);
    })
    .attr("fill", function(d) {
      return vis.color(isFinite(d.value) ? d.value : 0);
    })
    .attr("fill-opacity", 0.2)
    .classed("highlighted", function(d) {
      return d.idx === vis.selectedCountryId;
    });
  // main text
  vis.mainText = vis.svg
    .selectAll(".mainText")
    .data(vis.data.series)
    .enter()
    .append("g")
    .attr("class", "mainText")
    .attr("id", "mainTextid")
    .attr("transform", function(d) {
      return "translate(" + vis.x(d.date) + ",0)";
    });
  vis.mainText
    .selectAll("text")
    .data(function(d) {
      return vis.data.country.map(function(key, i) {
        return { value: d.values[i], idx: key };
      });
    })
    .enter()
    .append("text")
    .attr("transform", function(d) {
      return d.idx === vis.selectedCountryId
        ? `translate(0, ${vis.y(d.value) + 10} )`
        : `translate(0,0)`;
    })
    .attr("x", vis.barwidth / 2)
    .style("text-anchor", "middle")
    .style("alignment-baseline", "hanging")
    .attr("class", function(d) {
      return "mainText" + d.idx;
    })
    .text(function(d) {
      return Number.isFinite(d.value) ? vis.formatYAxis(d.value) : "";
    })
    .classed("highlighted", function(d) {
      return d.idx === vis.selectedCountryId;
    });

  // lines on the right
  // set the x range and domain (y is the same domain as line chart)
  vis.xMax = 10;
  // set the x range and domain
  vis.xKer = scaleLinear()
    .range([vis.width - vis.margin.right, vis.width - vis.margin.right * 0.5])
    .domain([0, vis.xMax])
    .nice();

  vis.sortedData = [];
  vis.data.country.forEach(function(key, i) {
    vis.sortedData.push({
      country: vis.data.country_long[i],
      value: vis.data.series[vis.selectedDateId].values[i],
      idx: key,
    });
  });
  vis.sortedData = sortByKey(vis.sortedData, "value");
  vis.nLen = vis.sortedData.length;
  vis.step = (vis.height - vis.margin.top - vis.margin.bottom) / (vis.nLen - 1);

  // right sorting lines
  vis.sortLines = vis.svg
    .selectAll(".sortLines")
    .data([vis.sortedData])
    .enter()
    .append("g")
    .attr("class", "sortLines")
    .attr("id", "sortLinesid");
  vis.sortLines
    .selectAll("line")
    .data(function() {
      return vis.sortedData.map(function(d) {
        return { country: d.country, value: d.value, idx: d.idx };
      });
    })
    .enter()
    .append("line")
    .attr("x1", vis.xKer(0))
    .attr("x2", vis.xKer((1 / 8) * vis.xMax))
    .attr("y1", function(d) {
      return vis.y(d.value);
    })
    .attr("y2", function(d) {
      return vis.y(d.value);
    })
    .style("opacity", function(d) {
      return +isFinite(d.value);
    })
    .attr("class", function(d) {
      return "sortLine" + d.idx;
    })
    .style("display", null)
    .attr("stroke", function(d) {
      return vis.color(isFinite(d.value) ? d.value : 0);
    })
    .classed("highlightedBind", function(d) {
      return d.idx === vis.selectedCountryId;
    });
  vis.sortLine2s = vis.svg
    .selectAll(".sortLine2s")
    .data([vis.sortedData])
    .enter()
    .append("g")
    .attr("class", "sortLine2s")
    .attr("id", "sortLine2sid");
  vis.sortLine2s
    .selectAll("line")
    .data(function() {
      return vis.sortedData.map(function(d, i) {
        return { country: d.country, value: d.value, id: i, idx: d.idx };
      });
    })
    .enter()
    .append("line")
    .attr("x1", vis.xKer((1 / 8) * vis.xMax))
    .attr("x2", vis.xKer((3 / 8) * vis.xMax))
    .attr("y1", function(d) {
      return vis.y(d.value);
    })
    .attr("y2", function(d) {
      return vis.height - vis.margin.bottom - vis.step * d.id;
    })
    .style("opacity", function(d) {
      return +isFinite(d.value);
    })
    .attr("class", function(d) {
      return "sortLine2" + d.idx;
    })
    .style("display", null)
    .attr("stroke", function(d) {
      return vis.color(isFinite(d.value) ? d.value : 0);
    })
    .classed("highlightedBind", function(d) {
      return d.idx === vis.selectedCountryId;
    });
  var sortLine3s = vis.svg
    .selectAll(".sortLine3s")
    .data([vis.sortedData])
    .enter()
    .append("g")
    .attr("class", "sortLine3s")
    .attr("id", "sortLine3sid");
  sortLine3s
    .selectAll("line")
    .data(function() {
      return vis.sortedData.map(function(d, i) {
        return { country: d.country, value: d.value, id: i, idx: d.idx };
      });
    })
    .enter()
    .append("line")
    .attr("x1", vis.xKer((3 / 8) * vis.xMax))
    .attr("x2", vis.xKer((1 / 2) * vis.xMax))
    .attr("y1", function(d) {
      return vis.height - vis.margin.bottom - vis.step * d.id;
    })
    .attr("y2", function(d) {
      return vis.height - vis.margin.bottom - vis.step * d.id;
    })
    .style("opacity", function(d) {
      return +isFinite(d.value);
    })
    .attr("class", function(d) {
      return "sortLine3" + d.idx;
    })
    .style("display", null)
    .attr("stroke", function(d) {
      return vis.color(isFinite(d.value) ? d.value : 0);
    })
    .classed("highlightedBind", function(d) {
      return d.idx === vis.selectedCountryId;
    });

  const gap = 2;
  vis.legend = vis.svg
    .selectAll(".legends")
    .data([vis.sortedData])
    .enter()
    .append("g")
    .attr("class", "legends")
    .attr("id", "legendid");
  vis.legend
    .selectAll("rect")
    .data(function() {
      return vis.sortedData.map(function(d, i) {
        return { country: d.country, value: d.value, id: i, idx: d.idx };
      });
    })
    .enter()
    .append("rect")
    .attr("x", vis.xKer((1 / 2) * vis.xMax) + 3 * gap)
    .attr("y", function(d) {
      return (
        vis.height -
        vis.margin.bottom -
        vis.step * d.id -
        (vis.xKer((1 / 8) * vis.xMax) - vis.xKer(0)) / 2 +
        gap
      );
    })
    .attr("width", vis.xKer((1 / 8) * vis.xMax) - vis.xKer(0) - gap * 2)
    .attr("height", vis.xKer((1 / 8) * vis.xMax) - vis.xKer(0) - gap * 2)
    .attr("fill", function(d) {
      return vis.color(isFinite(d.value) ? d.value : 0);
    })
    .attr("stroke", function(d) {
      return vis.color(isFinite(d.value) ? d.value : 0);
    })
    .attr("stroke-width", 2)
    .on("click", function(d) {
      vis.updateVis(d);
    });

  var sortTexts = vis.svg
    .selectAll(".sortTexts")
    .data([vis.sortedData])
    .enter()
    .append("g")
    .attr("class", "sortTexts")
    .attr("id", "sortTextsid");
  sortTexts
    .selectAll("text")
    .data(function() {
      return vis.sortedData.map(function(d, i) {
        return { country: d.country, id: i, idx: d.idx };
      });
    })
    .enter()
    .append("text")
    .attr("transform", function(d) {
      return `translate(${vis.xKer((5 / 8) * vis.xMax) +
        3 * gap}, ${vis.height - vis.margin.bottom - vis.step * d.id} )`;
    })
    .attr("dx", ".71em")
    .style("text-anchor", "start")
    .style("alignment-baseline", "central")
    .text(function(d) {
      return d.country;
    })
    .attr("class", function(d) {
      return "sortText" + d.idx;
    })
    .classed("highlightedText", function(d) {
      return d.idx === vis.selectedCountryId;
    });

  function clearHover() {
    selectAll(".hoved").classed("hoved", false);
    vis.svg
      .selectAll(".mainText")
      .selectAll("text")
      .attr("transform", function(d) {
        return d.idx === vis.selectedCountryId && Number.isFinite(d.value)
          ? `translate(0, ${vis.y(d.value) + 10} )`
          : `translate(0,0)`;
      });
  }

  function mouseoverF(d) {
    if (d === undefined || d.idx === undefined) return;
    clearHover();
    selectAll(".mainLine" + d.idx).classed("hoved", true);
    selectAll(".mainText" + d.idx)
      .classed("hoved", true)
      .attr("transform", function(d) {
        return Number.isFinite(d.value)
          ? `translate(0, ${vis.y(d.value) + 10} )`
          : `translate(0,0)`;
      });
    selectAll(".bindLine" + d.idx).classed("hoved", true);
    selectAll(".kernelLine" + d.idx).classed("hoved", true);
    selectAll(".sortLine" + d.idx).classed("hoved", true);
    selectAll(".sortLine2" + d.idx).classed("hoved", true);
    selectAll(".sortLine3" + d.idx).classed("hoved", true);
    selectAll(".sortText" + d.idx).classed("hoved", true);
  }

  function mouseoutF() {
    clearHover();
  }

  function hoverAll() {
    select("#svg-fundamentals")
      .selectAll("rect")
      .on("mouseover", mouseoverF)
      .on("mouseout", mouseoutF);
  }

  hoverAll();
};

MacroChart.prototype.updateVis = function(d) {
  var vis = this;
  // ================================== UPDATE FUNCTION ================================== //
  // Update the array to filter the chart by:
  // add the clicked key if not included:
  if (vis.filtered.indexOf(d.idx) === -1) {
    vis.filtered.push(d.idx);
    // if all bars are un-checked, reset:
    if (vis.filtered.length === vis.data.country.length) vis.filtered = [];
  }
  // otherwise remove it:
  else {
    vis.filtered.splice(vis.filtered.indexOf(d.idx), 1);
  }

  let ctry = vis.data.country;
  let filteredNum = vis.filtered.map((d) => ctry.indexOf(d));
  vis.minimal = Math.min(
    0,
    min(vis.data.series, (d) =>
      min(d.values, function(d, i) {
        return filteredNum.indexOf(i) === -1 ? d : 0;
      }),
    ),
  );
  vis.maximal = Math.max(
    0,
    max(vis.data.series, (d) =>
      max(d.values, function(d, i) {
        return filteredNum.indexOf(i) === -1 ? d : 0;
      }),
    ),
  );
  vis.dlt = (vis.maximal - vis.minimal) * 0.025;
  vis.minimal -= vis.minimal === 0 ? 0 : vis.dlt;
  vis.maximal += vis.maximal === 0 ? 0 : vis.dlt;
  vis.y = scaleLinear()
    .range([vis.height - vis.margin.bottom, vis.margin.top])
    .domain([vis.minimal, vis.maximal]);

  vis.limit = Math.max(Math.abs(vis.minimal), Math.abs(vis.maximal));
  vis.colorLimits = [
    -vis.limit,
    -vis.limit * 0.5,
    0,
    vis.limit * 0.5,
    vis.limit,
  ];
  // Data and color scale
  vis.color.domain(vis.colorLimits); //interpolateHsl interpolateHcl interpolateRgb;

  // update the y-axis:
  vis.svg
    .select(".axis--y-fund")
    .transition()
    .call(
      axisLeft(vis.y)
        .tickFormat(vis.formatYAxis) // TODO: ojo si no todos estan en %
        .tickPadding(10)
        .tickSize(-vis.width + vis.margin.right + vis.margin.left)
        .ticks(8),
    )
    .duration(500);

  // Filter out the mainlines that need to be hidden:
  vis.mainLines = vis.svg
    .selectAll(".mainLines")
    .selectAll("rect")
    .data(function(d) {
      return vis.data.country.map(function(key, i) {
        return {
          key: key,
          value: d.values[i],
          color: vis.sortRef[i],
          idx: key,
          id: i,
          date: d.date,
          country: vis.data.country[i],
        };
      });
    });
  vis.mainLines
    .filter(function(d) {
      return vis.filtered.indexOf(d.idx) > -1;
    })
    .transition()
    .attr("x", vis.delta)
    .attr("height", 0)
    .attr("y", 0)
    .duration(500);
  // Filter out the binding lines that need to be hidden:
  vis.bindLines = vis.svg
    .selectAll(".bindLines")
    .selectAll("line")
    .data(function(d) {
      return vis.data.country.map(function(key, i) {
        return {
          y1: d.y1[i],
          y2: d.y2[i],
          idx: key,
          country: vis.data.country[i],
        };
      });
    });
  vis.bindLines
    .filter(function(d) {
      return vis.filtered.indexOf(d.idx) > -1;
    })
    .transition()
    .attr("x1", -vis.delta)
    .attr("x2", +vis.delta)
    .attr("y1", 0)
    .attr("y2", 0)
    .style("opacity", 0)
    .duration(500);
  // Filter out text that needs to be hidden:
  vis.mainText = vis.svg
    .selectAll(".mainText")
    .selectAll("text")
    .data(function(d) {
      return vis.data.country.map(function(key, i) {
        return { value: d.values[i], idx: key };
      });
    });
  vis.mainText
    .filter(function(d) {
      return vis.filtered.indexOf(d.idx) > -1;
    })
    .transition()
    .attr("transform", `translate(0,0)`)
    .attr("fill", "rgba(0,0,0,0)")
    .attr("stroke", "rgba(0,0,0,0)")
    .duration(500);
  // Filter out the right sorting lines that need to be hidden:
  vis.sortLines = vis.svg
    .selectAll(".sortLines")
    .selectAll("line")
    .data(function() {
      return vis.sortedData.map(function(d, i) {
        return { country: d.country, value: d.value, id: i, idx: d.idx };
      });
    });
  vis.sortLines
    .filter(function(d) {
      return vis.filtered.indexOf(d.idx) > -1;
    })
    .transition()
    .attr("x1", vis.xKer((1 / 8) * vis.xMax))
    .attr("x2", vis.xKer((1 / 8) * vis.xMax))
    .style("opacity", 0)
    .duration(500);
  // Filter out the right sorting lines that need to be hidden:
  vis.sortLine2s = vis.svg
    .selectAll(".sortLine2s")
    .selectAll("line")
    .data(function() {
      return vis.sortedData.map(function(d, i) {
        return { country: d.country, value: d.value, id: i, idx: d.idx };
      });
    });
  vis.sortLine2s
    .filter(function(d) {
      return vis.filtered.indexOf(d.idx) > -1;
    })
    .transition()
    .attr("y1", function(d) {
      return vis.y(d.value);
    })
    .attr("y2", function(d) {
      return vis.y(d.value);
    })
    .style("opacity", 0)
    .duration(500);

  // Adjust the remaining bars:
  vis.mainLines
    .filter(function(d) {
      return vis.filtered.indexOf(d.idx) === -1;
    })
    .transition()
    .attr("x", vis.delta)
    .attr("y", function(d) {
      return Number.isFinite(d.value)
        ? vis.y(d.value) - vis.lineWidthChart / 2
        : 0;
    })
    .attr("height", 4)
    .attr("width", vis.candlewidth)
    .attr("stroke", function(d) {
      return Number.isFinite(d.value) ? vis.color(d.value) : "rgba(0,0,0,0)";
    })
    .attr("fill", function(d) {
      return Number.isFinite(d.value) ? vis.color(d.value) : "rgba(0,0,0,0)";
    })
    .attr("fill-opacity", 0.2)
    .style("opacity", function(d) {
      return +isFinite(d.value);
    })
    .attr("class", function(d) {
      return d.idx === vis.selectedCountryId
        ? "mainLine" + d.idx + " highlighted"
        : "mainLine" + d.idx;
    })
    .duration(500);

  // Adjust the remaining binding lines:
  vis.bindLines
    .filter(function(d) {
      return vis.filtered.indexOf(d.idx) === -1;
    })
    .transition()
    .attr("x1", -vis.delta)
    .attr("x2", +vis.delta)
    .attr("y1", function(d) {
      return vis.y(d.y1);
    })
    .attr("y2", function(d) {
      return vis.y(d.y2);
    })
    .style("opacity", function(d) {
      return +(isFinite(d.y1) && Number.isFinite(d.y2));
    })
    .style("display", null)
    .attr("class", function(d) {
      return d.idx === vis.selectedCountryId
        ? "bindLine" + d.idx + " highlightedBind"
        : "bindLine" + d.idx;
    })
    .duration(500);
  // Adjust the remaining text:
  vis.mainText
    .filter(function(d) {
      return vis.filtered.indexOf(d.idx) === -1;
    })
    .transition()
    .attr("transform", function(d) {
      return d.idx === vis.selectedCountryId && Number.isFinite(d.value)
        ? `translate(0, ${vis.y(d.value) + 10} )`
        : `translate(0,0)`;
    })
    .attr("x", vis.barwidth / 2)
    .style("text-anchor", "middle")
    .style("alignment-baseline", "hanging")
    .attr("class", function(d) {
      return "mainText" + d.idx;
    })
    .text(function(d) {
      return Number.isFinite(d.value) ? vis.formatYAxis(d.value) : "";
    })
    .attr("fill", function(d) {
      return d.idx === vis.selectedCountryId
        ? textactive(vis.colorTheme)
        : "rgba(0,0,0,0)";
    })
    .duration(500);
  // Adjust the remaining sorting lines:
  vis.sortLines
    .filter(function(d) {
      return vis.filtered.indexOf(d.idx) === -1;
    })
    .transition()
    .attr("x1", vis.xKer(0))
    .attr("x2", vis.xKer((1 / 8) * vis.xMax))
    .attr("y1", function(d) {
      return vis.y(d.value);
    })
    .attr("y2", function(d) {
      return vis.y(d.value);
    })
    .style("opacity", function(d) {
      return +isFinite(d.value);
    })
    .style("display", null)
    .attr("class", function(d) {
      return d.idx === vis.selectedCountryId
        ? "sortLine" + d.idx + " highlightedBind"
        : "sortLine" + d.idx;
    })
    .attr("stroke", function(d) {
      return vis.color(isFinite(d.value) ? d.value : 0);
    })
    .duration(500);
  // Adjust the remaining sorting2 lines:
  vis.sortLine2s
    .filter(function(d) {
      return vis.filtered.indexOf(d.idx) === -1;
    })
    .transition()
    .attr("x1", vis.xKer((1 / 8) * vis.xMax))
    .attr("x2", vis.xKer((3 / 8) * vis.xMax))
    .attr("y1", function(d) {
      return vis.y(d.value);
    })
    .attr("y2", function(d) {
      return vis.height - vis.margin.bottom - vis.step * d.id;
    })
    .style("opacity", function(d) {
      return +isFinite(d.value);
    })
    .style("display", null)
    .attr("class", function(d) {
      return d.idx === vis.selectedCountryId
        ? "sortLine2" + d.idx + " highlightedBind"
        : "sortLine2" + d.idx;
    })
    .attr("stroke", function(d) {
      return vis.color(isFinite(d.value) ? d.value : 0);
    })
    .duration(500);

  // update legend:
  vis.legend
    .selectAll("rect")
    .transition()
    .attr("stroke", function(d) {
      return vis.color(isFinite(d.value) ? d.value : 0);
    })
    .attr("fill", function(d) {
      if (vis.filtered.length) {
        if (vis.filtered.indexOf(d.idx) === -1) {
          return vis.color(isFinite(d.value) ? d.value : 0);
        } else {
          return "rgba(0,0,0,0)";
        }
      } else {
        return vis.color(isFinite(d.value) ? d.value : 0);
      }
    })
    .duration(100);
};
